module.exports = __webpack_public_path__ + "static/gubretas4-e02efa295eda1c06640602b9edbfb0fe.png";